import React, { useState, useEffect } from "react";
import "common/css/master.css";
import "../css/transport.css";
import { toast, ToastContainer } from "react-toastify";
import { getStudentAllocationStopListSvc } from "./routeSvc";

const RouteStopListTable = (props) => {
  const [loader, setLoader] = useState("none");
  const [routeId, setRouteId] = useState(props.routeId);
  const [lstStop, setLstStop] = useState([]);

  useEffect(() => {
    setRouteId(props.routeId);
    getStopListByRoute(props.routeId, cbStopList);
  }, [props.routeId]);

  function getStopListByRoute(pRouteId) {
    getStudentAllocationStopListSvc(pRouteId, cbStopList);
  }
  function cbStopList(data) {
    console.log('cbStopList()::', data)
    if (data.SvcStatus === "Success") {
      setLstStop(data.lstStop);
    } else {
      toast.error(data.SvcMsg);
    }
    setLoader("none");
  }


  const colgrp = (
    <colgroup>
      <col width="5%"></col>
      <col width="12%"></col>
      <col width="12%"></col>
      <col width="9%"></col>
      <col width="9%"></col>
      <col width="10%"></col>
    </colgroup>
  );
  return (
    <div style={{ pointerEvents: loader === "none" ? "auto" : "none" }}>
      <div className="">
        <div
          className="tab-pane fade active in"
          id="morning"
          style={{ fontWeight: "normal" }}
        >
          <div className="row">
            <div className="col-sm-12 form-group">
              <div
                className="pull-left padding-remove col-sm-2"
                style={{ border: "1px solid #b4b4b4" }}
              >
                <label
                  className="col-sm-7 control-label padding-remove"
                  style={{
                    color: "#fff",
                    background: "#ccc",
                  }}
                >
                  Route No.:
                </label>
                <label className="col-sm-5 control-label padding-remove pull-right">
                  {props.routeNo}
                </label>
              </div>

            </div>
          </div>
          <div className="row">
            <div className="col-sm-11" style={{ width: "95%" }}>
              <table className="tableLayout1">
                {colgrp}
                <thead>
                  <tr>
                    <th>Stop No.</th>
                    <th>Description</th>
                    <th>Address</th>
                    <th>City</th>
                    <th>Lat-Long</th>
                    <th>Action</th>
                  </tr>
                </thead>
              </table>
              <div className="tablebodyWrapper5" >
                <table className="tableLayout">
                  {colgrp}
                  <tbody>
                    {lstStop.map((obj, idx) => {
                      return (
                        <tr
                          key={idx}
                          route-id={routeId}
                          stop-id={obj.stopId}
                          id={obj.stopId}
                          onClick={(e) => props.setStopId(obj.stopId)}
                          className={
                            obj.stopId === props.stopId ? "selected" : ""
                          }
                        >
                          <td className="no-display">{obj.stopId}</td>
                          <td>{obj.stopNo}</td>
                          <td className="text-left">{obj.stopDesc}</td>
                          <td className="text-left">{obj.stopAddress}</td>
                          <td className="text-left">{obj.stopCity}</td>
                          <td className="text-left">{obj.stopLatLng}</td>

                          <td className="text-center">
                            <span
                              onClick={(e) => {
                                props.setStopId(obj.stopId);
                                props.setStopObj(obj)
                                props.openStudentAllocationSlider();
                              }}
                              className="glyphicon glyphicon-user"
                            ></span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
        
      </div>
    </div>
  );
};
export default RouteStopListTable;
